/* global ENV_CONFIG */
import { disableBiSend } from '../bi/bi-core';

function setup() {
  if (ENV_CONFIG.disableBi) {
    disableBiSend();
  }
}

export const setupEnv = () => {
  try {
    setup();
  } catch (er) {
    console.error('Cannot setup environment', er); // eslint-disable-line no-console
  }
};



// WEBPACK FOOTER //
// ./src/shared/env/setup-env.js